import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Button } from "../../../components/Button/Button";
import { http } from "../../../utils/httpCommon";
import { toast } from "react-hot-toast";
import ModalComponent from "../../../components/Modal/Modal";
import { TextInput } from "../../../components/TextInput/TextInput";
import { ErrorMessage } from "@hookform/error-message";

const DeleteReceivableModal = ({ receivableId, onSuccess }) => {
  const [opened, setOpened] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    adminPassword: "",
  });

  const [submitLoading, setSubmitLoading] = useState(false);

  const onSubmit = async (passedData) => {
    try {
      setSubmitLoading(true);
      if (!receivableId) {
        toast.error("Item id is empty, Contact dev team.");
        return false;
      }

      const r = await http.delete(`/receivables/${receivableId}`, {
        data: JSON.stringify({
          adminPassword: passedData.adminPassword,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });
      console.log(r.data);
      toast.success("Receivable deleted successfully");

      reset();
      setOpened(false);
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "An error occurred");
    } finally {
      setSubmitLoading(false);
    }
  };

  const handleOpen = () => {
    setOpened(true);
  };

  const handleClose = () => {
    setOpened(false);
    reset();
  };

  return (
    <>
      <Button variant={"destructive"} onClick={handleOpen}>
        Delete
      </Button>

      <ModalComponent opened={opened} setOpened={setOpened}>
        <div className="text-[24px] font-bold">Delete Receivable</div>
        <div className="text-[14px] text-gray-600 mb-4">
          This action will permanently delete the unpaid receivable. This action cannot be undone.
        </div>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="flex flex-col justify-center items-center gap-[40px] mt-4"
        >
          <div className="w-[100%]">
            <TextInput
              label={"Admin Password"}
              type="password"
              {...register("adminPassword", { required: true })}
            ></TextInput>
            <ErrorMessage
              name="adminPassword"
              errors={errors}
              render={({ message }) => <p className="text-red-500">{message}</p>}
            />
          </div>

          <div className="flex justify-end gap-4  w-full">
            <Button secondary={true} invert={true} onClick={handleClose}>
              Cancel
            </Button>
            <Button loading={submitLoading} secondary={true} type="submit">
              Confirm
            </Button>
          </div>
        </form>
      </ModalComponent>
    </>
  );
};

export default DeleteReceivableModal;
